<template>
  <div v-if="(editable && checkMemberId) || !editable">
    <b-row class="component-margin">
      <b-col sm="2">
          <b-input size="sm" v-model="nameFilter" placeholder="追跡番号、FBA番号"/>
      </b-col>
      <b-col sm="3">
        <b-btn size="sm" @click="outputCsv(null)" variant="danger">ファイル出力</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="filteredItems" :fields="fields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="date" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="totalShippingCost" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="forcastShippingCost" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="forcastShippingCost" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="forcastTargetSales" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="forcastTargetProfit" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="actualSales" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="actualProfit" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
        </b-table>
        <div md="6" v-if="(editable && memberId !== '') || !editable">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SellerSelectModal from '@/components/common/SellerSelectModal';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    },
    imember: {
      default: '',
    },
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'shippingDate' , label: '発送日', variant: 'base', sortable: true },
        { key: 'trackingNumber' , label: '追跡番号', variant: 'base', sortable: true },
        { key: 'fbaNumber'  , label: 'FBA番号', variant: 'base', sortable: true },
        { key: 'totalShippingCost'  , label: '送料合計', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'forcastShippingCost'  , label: '見込み送料', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'shippingFactor' , label: '送料係数', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'forcastTargetSales'  , label: 'T売上', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'forcastTargetProfit'  , label: 'T利益', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'actualSales'  , label: '実際売上', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'actualProfit' , label: '実際利益', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'profitRate'  , label: '利益率', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'salesRate'  , label: '販売率', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'forcastTagetSalesRate' , label: 'T売上達成率', variant: 'base', sortable: true, class: 'table-right' },
        { key: 'forcastTargetProfitRate' , label: 'T利益達成率', variant: 'base', sortable: true, class: 'table-right' },
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      nameFilter: '',
      filter: '',
      editItem: {},
      confirmMessage: '',
      memberId: '',
    };
  },
  computed: {
    filteredItems() {
      let filteredItems = this.items.filter(item => {
        return (this.nameFilter === '' || (item.fbaNumber !== null && item.fbaNumber.indexOf(this.nameFilter) !== -1) ||
                  (item.trackingNumber !== null && item.trackingNumber.indexOf(this.nameFilter) !== -1));
        });
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      return filteredItems;
    },
    checkMemberId() {
      if(this.imember !== ''){
        this.memberId = this.imember;
        api.getAnalysisShipmentFee(this.memberId, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
        });
        return true;
      }
      return false;
    },
  },
  created() {
    if (this.editable === false) {
      this.memberId = this.$store.state.account;
      api.getAnalysisShipmentFee(this.memberId, (items) => {
        this.items = items;
        this.totalRows = this.items.length;
      });
    }
  },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
      api.getAnalysisShipmentFee(this.memberId, (items) => {
        this.items = items;
        this.totalRows = this.items.length;
      });
    },
    outputCsv() {
      let csv = '\ufeff' + '発送日,追跡番号,FBA番号,送料合計,見込み送料,送料係数,T売上,T利益,実際売上,実際利益,利益率,販売率,T売上達成率,T利益達成率\n';
      let ids = [ 'shippingDate', 'trackingNumber', 'fbaNumber', 'totalShippingCost', 'forcastShippingCost', 'shippingFactor', 'forcastTargetSales', 'forcastTargetProfit', 'actualSales', 'actualProfit', 'profitRate', 'salesRate', 'forcastTagetSalesRate', 'forcastTargetProfitRate' ];
      let fileName = '';
      for (const item of this.items) {
        for (const id of ids) {
          csv += item[id] + ',';
        }
        csv += '\n';
      }
      fileName = '送料分析.csv';
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};

Vue.component('seller-select-modal', SellerSelectModal);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .table-right  { text-align:right!important; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center!important; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center!important; }
  .table-lw15 { max-width: 15rem; word-wrap: break-word;          text-align:left!important;   }
  .table-lw6  { max-width: 6rem; }
}
</style>
